import { configureStore } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
// import storageSession from 'reduxjs-toolkit-persist/lib/storage/session'
import { combineReducers } from 'redux'
import { persistReducer, persistStore } from 'redux-persist'
import thunk from 'redux-thunk'

import siteMapReducer from './slices/siteMapSlice'
import configReducer from './slices/configSlice'

const reducers = combineReducers({
  siteMap: siteMapReducer,
  config: configReducer,
})

const persistConfig = {
  key: 'root',
  storage, // or storageSession
  //   whitelist: ['activePOI', 'activeScene', 'myLocation', 'case'],
  //   blacklist: ['user', 'debug']
}

const persistedReducer = persistReducer(persistConfig, reducers)

export default configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk],
})
